export enum DepartmentPauseLogReason {
  Created = 1,
  EditedScheduled = 2,
  Activated = 3,
  EditedActive = 4,
  Finished = 5,
  CanceledScheduled = 6,
  CanceledActive = 7,
}

export enum DepartmentPauseLogState {
  Scheduled = 1,
  Active = 2,
  Finished = 3,
  Canceled = 4,
  Finishing = 5,
}

export const departmentPauseLogReasonLabels: Record<number, string> = {
  [DepartmentPauseLogReason.Created]: 'departmentPauseLogReason_Created',
  [DepartmentPauseLogReason.EditedScheduled]: 'departmentPauseLogReason_EditedScheduled',
  [DepartmentPauseLogReason.Activated]: 'departmentPauseLogReason_Activated',
  [DepartmentPauseLogReason.EditedActive]: 'departmentPauseLogReason_EditedActive',
  [DepartmentPauseLogReason.Finished]: 'departmentPauseLogReason_Finished',
  [DepartmentPauseLogReason.CanceledScheduled]: 'departmentPauseLogReason_CanceledScheduled',
  [DepartmentPauseLogReason.CanceledActive]: 'departmentPauseLogReason_CanceledActive',
};

export const departmentPauseLogStateLabels: Record<number, string> = {
  [DepartmentPauseLogState.Scheduled]: 'departmentPauseLogState_Scheduled',
  [DepartmentPauseLogState.Active]: 'departmentPauseLogState_Active',
  [DepartmentPauseLogState.Finished]: 'departmentPauseLogState_Finished',
  [DepartmentPauseLogState.Canceled]: 'departmentPauseLogState_Canceled',
  [DepartmentPauseLogState.Finishing]: 'departmentPauseLogState_Finishing',
};
